import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Grid,
  Box,
  Alert,
  Card,
  CardContent,
  CardActions,
  Chip,
  LinearProgress,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  InputLabel,
  Modal
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import VideocamIcon from '@mui/icons-material/Videocam';
import EditIcon from '@mui/icons-material/Edit';
import LockIcon from '@mui/icons-material/Lock';
import CloseIcon from '@mui/icons-material/Close';
import api from '../axios';
import Header from '../components/Header';
import Footer from '../components/Footer';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.conectachurch.com.br';

export default function AreaAluno({ onLogout }) {
  const [aluno, setAluno] = useState(null);
  const [aulas, setAulas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  // Matrícula
  const [minhasTurmas, setMinhasTurmas] = useState([]);
  const [turmasDisponiveis, setTurmasDisponiveis] = useState([]);
  const [turmaId, setTurmaId] = useState('');
  const [matriculaMsg, setMatriculaMsg] = useState('');
  const [matriculaError, setMatriculaError] = useState('');
  const [matriculaRemoveMsg, setMatriculaRemoveMsg] = useState('');
  const [matriculaRemoveError, setMatriculaRemoveError] = useState('');
  
  // Modals
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [senhaModalOpen, setSenhaModalOpen] = useState(false);
  
  // Form states
  const [form, setForm] = useState({});
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [senhaSuccess, setSenhaSuccess] = useState(false);
  const [senhaError, setSenhaError] = useState('');
  
  // Timer para contador regressivo
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    fetchDados();
    
    // Atualizar relógio a cada segundo
    const timer = setInterval(() => {
      setNow(new Date());
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);

  const fetchDados = async () => {
    try {
      setLoading(true);
      
      // Buscar dados do aluno
      const resAluno = await api.get('/alunos/me');
      setAluno(resAluno.data);
      setForm(resAluno.data);
      
      // Buscar matrículas
      const resMinhasTurmas = await api.get('/matriculas/minhas');
      console.log('📚 Matrículas carregadas:', resMinhasTurmas.data);
      setMinhasTurmas(resMinhasTurmas.data || []);
      
      // Buscar turmas disponíveis
      const resTurmas = await api.get('/turmas/');
      console.log('🎓 Turmas disponíveis:', resTurmas.data);
      setTurmasDisponiveis(resTurmas.data || []);
      
      // Buscar aulas
      const resAulas = await api.get('/aulas/minhas');
      setAulas(resAulas.data);
      
      setLoading(false);
    } catch (err) {
      console.error('❌ Erro ao carregar dados:', err);
      setError('Erro ao carregar dados');
      setLoading(false);
    }
  };

  const handleMarcarFrequencia = async (aulaId) => {
    try {
      await api.post('/frequencias/', {
        aluno_id: aluno.id,
        aula_id: aulaId,
        presente: true
      });
      setSuccess('Presença registrada com sucesso!');
      fetchDados();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      const errorMsg = err.response?.data?.detail || 
                       err.response?.data?.msg || 
                       (typeof err.response?.data === 'string' ? err.response?.data : null) ||
                       err.message || 
                       'Erro ao registrar presença';
      setError(errorMsg);
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const { email, senha, documentos, ...dadosEditaveis } = form;
      await api.put('/alunos/me', dadosEditaveis);
      setSuccess('Dados atualizados com sucesso!');
      setEditModalOpen(false);
      fetchDados();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      const errorMsg = err.response?.data?.detail || 
                       err.response?.data?.msg || 
                       (typeof err.response?.data === 'string' ? err.response?.data : null) ||
                       err.message || 
                       'Erro ao atualizar dados';
      setError(errorMsg);
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleSenhaSave = async (e) => {
    e.preventDefault();
    try {
      await api.put('/alunos/senha', {
        senha_atual: senhaAtual,
        nova_senha: novaSenha
      });
      setSenhaSuccess(true);
      setTimeout(() => {
        setSenhaModalOpen(false);
        setSenhaSuccess(false);
        setSenhaAtual('');
        setNovaSenha('');
      }, 2000);
    } catch (err) {
      const errorMsg = err.response?.data?.detail || 
                       err.response?.data?.msg || 
                       (typeof err.response?.data === 'string' ? err.response?.data : null) ||
                       err.message || 
                       'Erro ao alterar senha';
      setSenhaError(errorMsg);
      setTimeout(() => setSenhaError(''), 3000);
    }
  };

  // Desfazer matrícula
  const handleDesfazerMatricula = async (turmaId) => {
    try {
      await api.delete(`/matriculas/minhas/${turmaId}`);
      setMatriculaRemoveMsg('Matrícula desfeita com sucesso!');
      setTimeout(() => setMatriculaRemoveMsg(''), 3000);
      fetchDados();
    } catch (err) {
      const errorMsg = err.response?.data?.detail || 
                       err.response?.data?.msg || 
                       (typeof err.response?.data === 'string' ? err.response?.data : null) ||
                       err.message || 
                       'Erro ao desfazer matrícula.';
      setMatriculaRemoveError(errorMsg);
      setTimeout(() => setMatriculaRemoveError(''), 3000);
    }
  };

  // Realizar matrícula
  const handleMatricula = async (e) => {
    e.preventDefault();
    setMatriculaMsg('');
    setMatriculaError('');
    if (!turmaId) {
      setMatriculaError('Selecione uma turma.');
      return;
    }
    try {
      await api.post('/matriculas/aluno', { turma_id: turmaId });
      setMatriculaMsg('Matrícula realizada com sucesso!');
      setTurmaId('');
      setTimeout(() => setMatriculaMsg(''), 3000);
      fetchDados();
    } catch (err) {
      const errorMsg = err.response?.data?.detail || 
                       err.response?.data?.msg || 
                       (typeof err.response?.data === 'string' ? err.response?.data : null) ||
                       err.message || 
                       'Erro ao matricular.';
      setMatriculaError(errorMsg);
      setTimeout(() => setMatriculaError(''), 3000);
    }
  };

  // Função para calcular estado do botão de frequência
  const calcularEstadoAula = (aula) => {
    if (!aula.data || !aula.horario) {
      return { podeMarcar: false, mensagem: 'Horário não definido', cor: 'secondary' };
    }

    // Parse da data e horário da aula
    const [h, m] = aula.horario.split(':');
    const dataAula = new Date(aula.data + 'T' + aula.horario);
    
    // Janela de marcação: 20 min antes até 30 min depois
    const inicioJanela = new Date(dataAula.getTime() - 20 * 60000);
    const fimJanela = new Date(dataAula.getTime() + 30 * 60000);
    
    const agora = now;

    // Se já marcou presença
    if (aula.presente === true) {
      return {
        podeMarcar: false,
        mensagem: 'Presença Confirmada',
        cor: 'success',
        icon: <CheckCircleIcon />,
        disabled: true
      };
    }

    // Se já marcou falta
    if (aula.presente === false) {
      return {
        podeMarcar: false,
        mensagem: 'Falta Registrada',
        cor: 'error',
        icon: <CancelIcon />,
        disabled: true
      };
    }

    // Dentro da janela de marcação
    if (agora >= inicioJanela && agora <= fimJanela) {
      // Aula ainda não começou (até 20 min antes de começar)
      if (agora < dataAula) {
        const diffMs = dataAula - agora;
        const diffMin = Math.floor(diffMs / 60000);
        const diffSeg = Math.floor((diffMs % 60000) / 1000);
        return {
          podeMarcar: true,
          mensagem: `Inicia em ${diffMin}:${diffSeg.toString().padStart(2, '0')}`,
          cor: 'primary',
          contador: true
        };
      }
      
      // Aula já começou (até 30 min depois)
      const diffMs = fimJanela - agora;
      const diffMin = Math.floor(diffMs / 60000);
      return {
        podeMarcar: true,
        mensagem: `Marcar Presença (${diffMin} min restantes)`,
        cor: 'warning',
        urgente: diffMin < 10
      };
    }

    // Passou do prazo
    if (agora > fimJanela) {
      return {
        podeMarcar: false,
        mensagem: 'Prazo Encerrado',
        cor: 'error',
        icon: <LockIcon />,
        disabled: true,
        falta: true
      };
    }

    // Ainda não liberou
    return {
      podeMarcar: false,
      mensagem: 'Aguardando Horário',
      cor: 'info',
      icon: <AccessTimeIcon />
    };
  };

  if (loading) {
    return (
      <>
        <Header onLogout={onLogout} />
        <Container sx={{ mt: 4, mb: 4 }}>
          <LinearProgress />
          <Typography sx={{ mt: 2 }}>Carregando...</Typography>
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header onLogout={onLogout} />
      <Container maxWidth="lg" sx={{ mt: { xs: 2, md: 4 }, mb: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
        {/* Cabeçalho */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" gutterBottom sx={{ fontSize: { xs: '1.3rem', md: '2rem' } }}>
            Olá, {aluno?.nome}!
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Aqui você pode acompanhar suas aulas e marcar presença.
          </Typography>
          <Box sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Button
              variant="outlined"
              startIcon={<EditIcon />}
              onClick={() => setEditModalOpen(true)}
            >
              Editar Dados
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setSenhaModalOpen(true)}
            >
              Alterar Senha
            </Button>
          </Box>
        </Box>

        {/* Mensagens */}
        {success && (
          <Alert severity="success" sx={{ mb: 3 }} onClose={() => setSuccess('')}>
            {success}
          </Alert>
        )}
        {error && (
          <Alert severity="error" sx={{ mb: 3}} onClose={() => setError('')}>
            {error}
          </Alert>
        )}
        
        {/* Alerta de cadastro incompleto */}
        {aluno && !aluno.cadastro_completo && (
          <Alert severity="warning" sx={{ mb: 3 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1 }}>
              ⚠️ Cadastro Incompleto
            </Typography>
            <Typography variant="body2">
              Por favor, complete seus dados cadastrais clicando em "Editar Dados" para ter acesso completo ao sistema.
            </Typography>
          </Alert>
        )}

        {/* Seção de Matrículas */}
        <Box sx={{ mb: 4, p: { xs: 2, md: 3 }, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
          <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.2rem', md: '1.5rem' } }}>
            Minhas Matrículas
          </Typography>
          
          {matriculaRemoveMsg && <Alert severity="success" sx={{ mb: 2 }}>{matriculaRemoveMsg}</Alert>}
          {matriculaRemoveError && <Alert severity="error" sx={{ mb: 2 }}>{matriculaRemoveError}</Alert>}
          
          {minhasTurmas.length === 0 ? (
            <Typography color="text.secondary">Nenhuma matrícula encontrada.</Typography>
          ) : (
            <Grid container spacing={2}>
              {minhasTurmas.map((matricula) => (
                <Grid item xs={12} sm={6} md={4} key={matricula.id}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="h6">{matricula.turma_nome}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        Período: {matricula.periodo_nome || '-'}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button
                        size="small"
                        color="error"
                        onClick={() => handleDesfazerMatricula(matricula.turma_id)}
                      >
                        Desfazer Matrícula
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}

          {/* Matrícula em nova turma */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" gutterBottom>Matrícula em Turma</Typography>
            {matriculaMsg && <Alert severity="success" sx={{ mb: 2 }}>{matriculaMsg}</Alert>}
            {matriculaError && <Alert severity="error" sx={{ mb: 2 }}>{matriculaError}</Alert>}
            
            {minhasTurmas.length > 0 && (
              <Alert severity="info" sx={{ mb: 2 }}>
                Você já está matriculado em uma turma. Para se matricular em outra, desfaça a matrícula atual.
              </Alert>
            )}
            
            <Box component="form" onSubmit={handleMatricula} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', flexDirection: { xs: 'column', sm: 'row' } }}>
              <TextField
                select
                label="Selecione a Turma"
                value={turmaId}
                onChange={(e) => setTurmaId(e.target.value)}
                disabled={minhasTurmas.length > 0}
                sx={{ minWidth: { xs: '100%', sm: 250 } }}
              >
                <MenuItem value="">Selecione...</MenuItem>
                {turmasDisponiveis.map((t) => (
                  <MenuItem key={t.id} value={t.id}>
                    {t.nome} - {t.periodo_nome}
                  </MenuItem>
                ))}
              </TextField>
              <Button
                type="submit"
                variant="contained"
                disabled={minhasTurmas.length > 0}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
              >
                Matricular
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Lista de Aulas */}
        <Typography variant="h5" gutterBottom sx={{ mb: 3, fontSize: { xs: '1.2rem', md: '1.5rem' } }}>
          Minhas Aulas
        </Typography>

        {aulas.length === 0 ? (
          <Alert severity="info" sx={{ mb: 2 }}>
            Você ainda não está matriculado em nenhuma turma.
          </Alert>
        ) : (
          <Grid container spacing={3}>
            {aulas.map((aula) => {
              const estado = calcularEstadoAula(aula);
              const diasSemana = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB'];
              const dataAulaObj = new Date(aula.data + 'T' + (aula.horario || '00:00'));
              const diaSemana = diasSemana[dataAulaObj.getDay()];

              return (
                <Grid item xs={12} sm={6} md={4} key={aula.id}>
                  <Card
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      transition: 'transform 0.2s, box-shadow 0.2s',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: 6
                      },
                      border: estado.urgente ? '2px solid #ff9800' : 'none'
                    }}
                  >
                    <CardContent sx={{ flexGrow: 1 }}>
                      {/* Data e Horário */}
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Chip
                            label={diaSemana}
                            size="small"
                            color="primary"
                            sx={{ fontWeight: 'bold' }}
                          />
                          <Typography variant="caption" color="text.secondary">
                            {dataAulaObj.toLocaleDateString('pt-BR')}
                          </Typography>
                        </Box>
                        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 'bold' }}>
                          {aula.horario || '-'}
                        </Typography>
                      </Box>

                      {/* Número da Lição */}
                      {aula.numero_licao && (
                        <Box sx={{ mb: 1 }}>
                          <Chip 
                            label={`Lição ${aula.numero_licao}`} 
                            color="secondary" 
                            size="small"
                            sx={{ fontWeight: 'bold' }}
                          />
                        </Box>
                      )}

                      {/* Lição e Turma */}
                      <Typography variant="h6" gutterBottom>
                        {aula.licao || 'Sem título'}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        {aula.turma_nome}
                      </Typography>
                      {aula.professor_nome && (
                        <Typography variant="body2" color="text.secondary" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          👨‍🏫 {aula.professor_nome}
                        </Typography>
                      )}

                      {/* Estado da Presença */}
                      <Box sx={{ mt: 2, mb: 2 }}>
                        <Chip
                          label={estado.mensagem}
                          color={estado.cor}
                          icon={estado.icon}
                          sx={{ width: '100%' }}
                        />
                      </Box>

                      {/* Materiais */}
                      <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap' }}>
                        {aula.pdf_path && (
                          <Button
                            size="small"
                            startIcon={<PictureAsPdfIcon />}
                            href={`https://api.start.smyrnaapp.cloud/aulas/${aula.id}/pdf`}
                            target="_blank"
                            variant="outlined"
                          >
                            📄 PDF
                          </Button>
                        )}
                        {aula.link_streaming && (
                          <Button
                            size="small"
                            startIcon={<VideocamIcon />}
                            href={aula.link_streaming}
                            target="_blank"
                            variant="outlined"
                            color="secondary"
                          >
                            🎥 Aula Online
                          </Button>
                        )}
                      </Box>
                    </CardContent>

                    {/* Botão de Marcar Presença */}
                    <CardActions sx={{ p: 2, pt: 0 }}>
                      <Button
                        fullWidth
                        variant={estado.podeMarcar ? 'contained' : 'outlined'}
                        color={estado.cor}
                        disabled={!estado.podeMarcar}
                        onClick={() => handleMarcarFrequencia(aula.id)}
                        startIcon={estado.icon}
                      >
                        {estado.podeMarcar ? 'Marcar Presença' : estado.mensagem}
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        )}

        {/* Modal Editar Dados */}
        <Modal open={editModalOpen} onClose={() => setEditModalOpen(false)}>
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: { xs: 2, sm: 3, md: 4 },
            borderRadius: 2,
            width: { xs: '95vw', sm: '85vw', md: '600px' },
            maxHeight: '85vh',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h6">Editar Dados Pessoais</Typography>
              <IconButton onClick={() => setEditModalOpen(false)} size="small">
                <CloseIcon />
              </IconButton>
            </Box>
            <Box component="form" onSubmit={handleSave} sx={{ overflowY: 'auto', flex: 1, pr: 1 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Nome"
                    value={form.nome || ''}
                    onChange={(e) => setForm({ ...form, nome: e.target.value })}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Telefone"
                    value={form.telefone || ''}
                    onChange={(e) => setForm({ ...form, telefone: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    select
                    label="Estado Civil"
                    value={form.estado_civil || ''}
                    onChange={(e) => setForm({ ...form, estado_civil: e.target.value })}
                  >
                    <MenuItem value="">Selecione</MenuItem>
                    <MenuItem value="Solteiro">Solteiro</MenuItem>
                    <MenuItem value="Casado">Casado</MenuItem>
                    <MenuItem value="Viúvo">Viúvo</MenuItem>
                    <MenuItem value="Divorciado">Divorciado</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    select
                    label="Sexo"
                    value={form.sexo || ''}
                    onChange={(e) => setForm({ ...form, sexo: e.target.value })}
                  >
                    <MenuItem value="">Selecione</MenuItem>
                    <MenuItem value="Masculino">Masculino</MenuItem>
                    <MenuItem value="Feminino">Feminino</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Data de Nascimento"
                    type="date"
                    value={form.data_nascimento || ''}
                    onChange={(e) => setForm({ ...form, data_nascimento: e.target.value })}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Endereço"
                    value={form.endereco || ''}
                    onChange={(e) => setForm({ ...form, endereco: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Bairro"
                    value={form.bairro || ''}
                    onChange={(e) => setForm({ ...form, bairro: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="CEP"
                    value={form.cep || ''}
                    onChange={(e) => setForm({ ...form, cep: e.target.value })}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    select
                    label="Motivo"
                    value={form.motivo || ''}
                    onChange={(e) => setForm({ ...form, motivo: e.target.value })}
                  >
                    <MenuItem value="">Selecione</MenuItem>
                    <MenuItem value="Conhecer mais sobre a Bíblia">Conhecer mais sobre a Bíblia</MenuItem>
                    <MenuItem value="Preparar para o batismo">Preparar para o batismo</MenuItem>
                    <MenuItem value="Crescimento espiritual">Crescimento espiritual</MenuItem>
                    <MenuItem value="Convite de amigo/familiar">Convite de amigo/familiar</MenuItem>
                    <MenuItem value="Outro">Outro</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    select
                    label="Tipo de Batismo"
                    value={form.tipo_batismo || ''}
                    onChange={(e) => setForm({ ...form, tipo_batismo: e.target.value })}
                  >
                    <MenuItem value="">Selecione</MenuItem>
                    <MenuItem value="imersão">Imersão</MenuItem>
                    <MenuItem value="aspersão">Aspersão</MenuItem>
                    <MenuItem value="católico">Católico</MenuItem>
                    <MenuItem value="não sou batizado">Não sou batizado</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Observações"
                    multiline
                    rows={3}
                    value={form.observacoes || ''}
                    onChange={(e) => setForm({ ...form, observacoes: e.target.value })}
                    placeholder="Informações adicionais..."
                  />
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ pt: 2, mt: 2, borderTop: '1px solid #e0e0e0' }}>
              <Button type="submit" variant="contained" color="primary" fullWidth onClick={handleSave}>
                Salvar
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Modal Alterar Senha */}
        <Modal open={senhaModalOpen} onClose={() => setSenhaModalOpen(false)}>
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            minWidth: 320
          }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h6">Alterar Senha</Typography>
              <IconButton onClick={() => setSenhaModalOpen(false)} size="small">
                <CloseIcon />
              </IconButton>
            </Box>
            <Box component="form" onSubmit={handleSenhaSave}>
              <TextField
                fullWidth
                label="Senha Atual"
                type="password"
                value={senhaAtual}
                onChange={(e) => setSenhaAtual(e.target.value)}
                required
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Nova Senha"
                type="password"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                required
                sx={{ mb: 2 }}
              />
              {senhaError && <Alert severity="error" sx={{ mb: 2 }}>{senhaError}</Alert>}
              {senhaSuccess && <Alert severity="success" sx={{ mb: 2 }}>Senha alterada!</Alert>}
              <Button type="submit" variant="contained" color="primary" fullWidth>
                Salvar Nova Senha
              </Button>
            </Box>
          </Box>
        </Modal>
      </Container>
      <Footer />
    </>
  );
}
